import { useQuery } from "@tanstack/react-query";
import { listarCobrancaPendentes } from "../services/cobranca";

// MELHORIA 13 — pendências de cobrança do atendimento logado. Reconsulta a cada
// 5 min (e ao focar a janela); é aqui que o backend também dispara o aviso de 48h.
export function useCobrancaCliente(ativo = true) {
  return useQuery({
    queryKey: ["cobranca-pendentes"],
    queryFn: listarCobrancaPendentes,
    enabled: ativo,
    refetchInterval: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    staleTime: 60 * 1000,
  });
}
